import React from 'react';
import { WithChildren } from '../../../../models/children-props';
import classes from './ChartTooltipContainer.module.scss';
export const ChartTooltipContainerView = ({ children }: WithChildren) => {
  return <div className={classes.Container}>{children}</div>;
};
